<template>
  <a-modal :title="!dataForm.id ? '新增隐私通话记录' : '修改隐私通话记录'" :visible="visible" :confirm-loading="confirmLoading"
    @ok="handleSubmit" @cancel="handleCancel" destroyOnClose :maskClosable="false" width="600px">
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="dataFormRef" :model="dataForm" :rules="rules" :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }">
        <a-form-model-item label="主叫手机号" prop="phoneB">
          <a-input v-model="dataForm.phoneB" placeholder="请输入主叫手机号" />
        </a-form-model-item>
        <a-form-model-item label="号码池" prop="pool_key">
          <a-select v-model="dataForm.pool_key" placeholder="请选择号码池">
            <a-select-option v-for="(item, index) in poollist" :key="index" :value="item.pool_key"
              :disabled="item.disabled">{{ item.pool_name
              }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="通话原因" prop="reson">
          <a-textarea v-model="dataForm.reson" placeholder="请输入通话原因" />
        </a-form-model-item>
        <a-form-model-item label="提示">
          申请通过的隐私号码默认有效期为1个小时
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      dataForm: {
        id: null,
        customer_id: '',
        phoneB: '',
        reson: '',  // Note: Backend API uses "reson" not "reason"
        pool_key: undefined
      },
      rules: {
        customer_id: [
          {
            required: true,
            message: '请输入客户ID',
            trigger: 'blur'
          }
        ],
        phoneB: [
          {
            required: true,
            message: '请输入被叫手机号',
            trigger: 'blur'
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入正确的手机号格式',
            trigger: 'blur'
          }
        ],
        reson: [
          {
            required: true,
            message: '请输入通话原因',
            trigger: 'blur'
          }
        ],
        pool_key: [
          {
            required: true,
            message: '请选择号码池',
            trigger: 'change'
          }
        ]
      },
      poollist: []
    };
  },
  methods: {
    init(id, customer_id) {
      this.visible = true;
      this.dataForm.id = id || null;
      this.getPoolSelect()
      // Reset form
      this.$nextTick(() => {
        this.$refs.dataFormRef.clearValidate();
      });
      // If adding new, set customer_id if provided
      if (customer_id) {
        this.dataForm.customer_id = customer_id;
      }
      // Ensure reson field is initialized
      if (!this.dataForm.reson) {
        this.dataForm.reson = '';
      }
    },
    getPoolSelect() {
      this.$http({
        url: '/admin/trip/poolselect',
        method: 'get',
      }).then(res => {
        this.poollist = res.data
      })
    },
    handleSubmit() {
      this.$refs.dataFormRef.validate(valid => {
        if (valid) {
          this.confirmLoading = true;

          // Use the exact API endpoint provided in the backend code
          const url = this.dataForm.id = '/admin/trip/createSecretReport';

          // Prepare the data according to the backend API signature
          const requestData = {
            customer_id: this.dataForm.customer_id,
            phoneB: this.dataForm.phoneB,
            reson: this.dataForm.reson,
            pool_key: this.dataForm.pool_key
          };

          this.$http({
            url,
            method: 'post',
            data: requestData
          })
            .then(res => {
              if (res.code === 1) {
                this.$message.success(`${this.dataForm.id ? '修改' : '新增'}成功`);
                this.handleCancel();
                this.$emit('ok');
              } else {
                this.$message.error(res.message || '操作失败');
              }
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log('Validation failed');
          return false;
        }
      });
    },

    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.$refs.dataFormRef.resetFields();
      this.$nextTick(() => {
        this.dataForm = {
          id: null,
          customer_id: '',
          phoneB: '',
          reson: '',
          pool_key: undefined
        };
      });
    }
  }
};
</script>

<style></style>